
import { IParamsReportSalaryStaff } from 'features/report/services/types/review';
import { useMemo } from 'react';
import shopSelectors from 'services/shop/selectors';
import { ETemplateReportSallary } from 'services/shop/types/setting';
import useDefaultPayrollTemplate from './defaultPayrollTemplate';
import useReceiptCashRoundUpDownTemplate from './cashRoundUpDownTemplate';
import useSimplePayrollTemplate from './simplePayrollTemplate';

const usePayrollTemplate = (params: IParamsReportSalaryStaff) => {
  const allSetting = shopSelectors.data.allSetting();
  const defaultTemplate = useDefaultPayrollTemplate(params);
  const cashRoundUpDownTemplate = useReceiptCashRoundUpDownTemplate(params);
  const simplePayrollTemplate = useSimplePayrollTemplate(params);

  const template = useMemo(() => {
    if (allSetting?.templateReportSalary === ETemplateReportSallary.RECEIPT_CASH_ROUND_UP_DOWN) {
      return cashRoundUpDownTemplate;
    }
    if (allSetting?.templateReportSalary === ETemplateReportSallary.SIMPLE_PAYROLL) {
      return simplePayrollTemplate;
    }
    return defaultTemplate;
  }, [defaultTemplate, cashRoundUpDownTemplate, simplePayrollTemplate]);

  return template;
};

export default usePayrollTemplate;
